export const radioFields = [
    {
        id: 1,
        value: "PUBLIC",
        label: "Public",
        showInfo: false,
    },
    {
        id: 2,
        value: "PRIVATE",
        label: "Private",
        showInfo: true,
        infoMessage: "Private Accounts do not come up in Search but can be accessed via URL"
    },
    {
        id: 3,
        value: "HIDDEN",
        label: "Hidden",
        showInfo: true,
        infoMessage: "Hidden accounts do not come up in Search and CANNOT be accessed via URL"
    }
];

export const followersVisibilityFields = [
    { id: 1, value: "EVERYONE", label: "Everyone", display: "Everyone" },
    { id: 2, value: "FOLLOWERS_ONLY", label: "Followers Only", display: "Followers only" },
    { id: 3, value: "NOBODY", label: "Nobody", display: "Nobody" },
];

export const getFollowPrivacyDisplay = (value) =>
    followersVisibilityFields.find((f) => f.value === value)?.display ?? value;